import ApiService from "./ApiService";
import AuthService from "./AuthService";

const CustomerService = {
  getConfig: () => {
    const url = "/v1/init";

    return ApiService.request(url);
  },

  getStats: url => {
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: `token ${AuthService.getUserToken()}`
      }
    });
  },

  overview: cid => {
    if (!cid) {
      return "/overview/";
    }
    return `/campaign/${cid}/overview/`;
  },

  monetization: cid => {
    if (!cid) {
      return "/monetization/";
    }
    return `/campaign/${cid}/monetization/`;
  },

  campaignCreate: () => {
    return "/campaign/create/";
  },

  campaignList: () => {
    return "/campaign/list/";
  },

  widgetList: cid => {
    return `/campaign/${cid}/widget/list/`;
  },

  announceList: (cid, status) => {
    const s = status == undefined ? STATUS_ACTIVE : status;
    if (!cid) {
      return `/announce/list/${s}/`;
    }
    return `/campaign/${cid}/announce/list/${s}/`;
  },

  payments: () => {
    return "/payments/";
  },

  paymentSuccess: () => {
    return "/payments/success/";
  },

  paymentFail: () => {
    return "/payments/fail/";
  },

  notFound: () => {
    return "/404";
  },

  serverError: () => {
    return "/500";
  },

  campaignStatExport: id => {
    if (!id) {
      return "/api/v1/campaigns/stat/export";
    }
    return `/api/v1/campaigns/${id}/stat/export`;
  },

  informerStatExport: id => {
    return `/api/v1/widgets/${id}/stat/export`;
  },

  teaserStatExport: id => {
    return `/api/v1/announcements/${id}/stat/export`;
  },

  teaserListStatExport: cid => {
    if (!cid) {
      return "/api/v1/announcements/stat/export";
    }
    return `/api/v1/campaigns/${cid}/announcements/export`;
  }
};

export default CustomerService;
